export type GeneralSettingsType = {
  isHomeTimerDefinedInCMS: boolean;
  homeTimer: number;
  resetTimer: number;
  languageSelective: boolean;
  controllers: {
    id: string;
    type: string | null;
    serialnumber: string | null;
  }[];
  nfcReaders: {
    id: string;
    type: string | null;
    channel: string | null;
  }[];
  buttons: {
    id: string;
    channel: string | null;
    buttonIdentifier: 'A' | 'B' | 'C' | 'D' | null;
    name: string | null;
  }[];
  buzzers: {
    id: string;
    channel: string | null;
    name: string | null;
  }[];
  leds: {
    id: string;
    channel: string | null;
    ledIdentifier: 'A' | 'B' | 'C' | 'D' | 'E' | 'X' | null;
    name: string | null;
  }[];
  screens: {
    id: string;
    screenNr: number | null;
    name: string | null;
    touchEnabled: boolean;
  }[];
  isSlideDeletionAllowed: boolean;
};

export enum SupportedColors {
  WHITE = 0,
  RED = 1,
  GREEN = 2,
  BLUE = 3,
  YELLOW = 4,
  MAGENTA = 5,
  CYAN = 6,
  ORANGE = 7,
  PINK = 8,
  LIME = 9,
}

export const LanguageOptions = [
  { value: 'DE' },
  { value: 'EN' },
  { value: 'FR' },
  { value: 'IT' },
  { value: 'JPN' },
  { value: 'KOR' },
  { value: 'CHN' },
  { value: null },
];

// Hardware Settings Overview
export type HardwareKey =
  | 'nfcReaders'
  | 'buttons'
  | 'buzzers'
  | 'leds'
  | 'screens';

export type HardwareOverview = {
  key: HardwareKey;
  count: number;
};
